import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=66e10afe&"
import script from "./LegalNotice.vue?vue&type=script&lang=js&"
export * from "./LegalNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LegalNotice.vue"
export default component.exports